import { graphql } from "gatsby";
import React from "react";
import "./videoIframe.scss";
import parse from "html-react-parser";

interface Props {
  iframeEmbedCode?: string;
  iframeAspectRatio?: string;
}

const VideoIframe: React.FC<Props> = (props) => {
  return (
    <div className="video-iframe">
      <div className="video-iframe__wrapper">
        <div className={'video-iframe__ratio ' + (!!props.iframeAspectRatio && parse(props.iframeAspectRatio))}>
          {!!props.iframeEmbedCode && parse(props.iframeEmbedCode)}
        </div>
      </div>
    </div>
  );
};

export const query = graphql`
  fragment VideoIframeBlock on WpAcfVideoiframeBlock {
    AcfVideoIframe {
      iframeEmbedCode
      iframeAspectRatio
    }
  }
`;

export default VideoIframe;
